import { render, staticRenderFns } from "./UserRecentStudyPage.vue?vue&type=template&id=723cc619&scoped=true"
import script from "./UserRecentStudyPage.vue?vue&type=script&lang=js"
export * from "./UserRecentStudyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723cc619",
  null
  
)

export default component.exports